// #moghavemat
// Do not change the order of data in this array
export const NETWORK_OPTIONS: { name: string }[] = [
  { name: 'گفتمان سازان' },
  { name: 'نهضت اجتماعی' },
  { name: 'سراج' },
  { name: 'روشنا' },
  { name: 'جامعه قرآنی نصر' },
  { name: 'فتح الفتوح' },
  { name: 'جهاد تبیین' },
  { name: 'تحول اجتماعی' },
  { name: 'گردشگری' },
  { name: 'تغذیه سالم' },
  { name: 'ورزش' },
  { name: 'مطالبه گری' },
  { name: 'حجاب و عفاف' },
  { name: 'جمعیت' },
]
